import type { StateCreator } from 'zustand'

import type { LoadingState } from './types'

const createLoadingSlice: StateCreator<LoadingState, [], [], LoadingState> = (set) => ({
  loading: { isLoading: false },
  setIsLoading: (isLoading) => set(() => ({ loading: { isLoading } })),
})

export default createLoadingSlice
